import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.3.1_@babel+core@7.26.8_@opentelemetry+api@1.9.0_react-dom@19.1.0_react@19.1.0__react@19.1.0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.3.1_@babel+core@7.26.8_@opentelemetry+api@1.9.0_react-dom@19.1.0_react@19.1.0__react@19.1.0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["useMenus"] */ "/vercel/path0/personly-libs/personly-libs-providers/dist/providers/menus.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/personly-libs/personly-libs-widgets/dist/widgets/button/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/personly-libs/personly-libs-widgets/dist/widgets/card-button/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/personly-libs/personly-libs-widgets/dist/widgets/checkbox/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/personly-libs/personly-libs-widgets/dist/widgets/consent/index.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/personly-libs/personly-libs-widgets/dist/widgets/delay/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/personly-libs/personly-libs-widgets/dist/widgets/icon-select/index.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/personly-libs/personly-libs-widgets/dist/widgets/masonry/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/personly-libs/personly-libs-widgets/dist/widgets/menu-links/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/personly-libs/personly-libs-widgets/dist/widgets/menu-toggler-button/index.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/personly-libs/personly-libs-widgets/dist/widgets/text-select/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/personly-libs/personly-libs-widgets/dist/widgets/textarea/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/personly-libs/personly-libs-widgets/dist/widgets/toast/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/personly-libs/personly-libs-widgets/dist/widgets/toggle-description/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/personly-libs/personly-libs-widgets/dist/widgets/toggle/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/personly-libs/personly-libs-widgets/dist/widgets/upload/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/personly-web/personly-web-splash/src/components/organization/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/personly-web/personly-web-splash/src/selects/scheme-select/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/personly-web/personly-web-splash/src/views/personals-locations-view/index.tsx");
